export type ClassListItem = string | false | undefined

function isString(value: ClassListItem): value is string {
  return typeof value === 'string' && value.length > 0
}

export function classNames(...classes: ClassListItem[]) {
  return classes.filter(isString).join(' ')
}
